import styles from "./postBadge.module.scss";
export interface IPostBadgeProps {
	category?: string | string[];
	featured?: boolean;
}

const PostBadge = ({ category, featured }: IPostBadgeProps): JSX.Element => {
	return (
		<div className={`${styles.badge}  ${featured && styles.featuredBadge} ${category && styles.categoryBadge}`}>
			<span>{featured ? "em destaque" : category}</span>
		</div>
	);
};

export default PostBadge;
